import { GET_CRITERIA } from "actions/types";
export default (state = null, action) => {
  switch (action.type) {
    case GET_CRITERIA:
      state = action.payload;
      return {
        data: state,
        alert: false
      };
    default:
      return state;
  }
};
